// extracted by mini-css-extract-plugin
export default {"main":"MiddleContent_main__0VSWq"};